import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import AppStoreButton from "./AppStoreButton";
import { APP_NAME } from "@/constants/site";

const Nav = () => (
  <motion.header
    initial={{ y: -90, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 inset-x-0 z-50"
    data-testid="site-nav"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="mt-4 flex h-16 items-center justify-between rounded-2xl border border-white/10 bg-white/[0.04] px-4 backdrop-blur-xl">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-brand-link">
          <Logo size={34} />
          <span className="font-heading text-sm sm:text-base font-bold tracking-tight text-white">
            {APP_NAME}
          </span>
        </Link>
        <div className="flex items-center gap-4">
          <span className="hidden sm:inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400" data-testid="ios-platform-badge">
            iOS App
          </span>
          <AppStoreButton variant="crimson" size="sm" testId="nav-app-store-button" />
        </div>
      </div>
    </div>
  </motion.header>
);

export default Nav;
